import { render, staticRenderFns } from "./tableForm.vue?vue&type=template&id=3ceb78f1&scoped=true&"
import script from "./tableForm.vue?vue&type=script&lang=js&"
export * from "./tableForm.vue?vue&type=script&lang=js&"
import style0 from "./tableForm.vue?vue&type=style&index=0&id=3ceb78f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceb78f1",
  null
  
)

export default component.exports